import React from 'react';

const ResourcesHeader = () => {
  return (
    <div className="page-hero-bg relative overflow-hidden text-white text-center bg-gradient-to-br from-icetex to-icetex-dark py-[80px] px-5">
      <div className="mx-auto relative z-10 max-w-[800px]">
        <h1
          className="font-extrabold mb-5"
          style={{ fontSize: '3rem', textShadow: '0 2px 10px rgba(0, 0, 0, 0.2)' }}
        >
          Centro de Recursos
        </h1>
        <p
          className="mx-auto opacity-[0.95]"
          style={{ fontSize: '1.2rem', lineHeight: '1.8', maxWidth: '700px' }}
        >
          Encuentra guías, cartillas y documentos diseñados especialmente para fortalecer tu
          bienestar, tu desarrollo personal y tu crecimiento académico.
        </p>
      </div>
    </div>
  );
};

export default ResourcesHeader;
